import { areCommunicationPreferencesPreselected, OrganizationCountry } from "@simplyk/common";

interface CommunicationPreferenceDefaults {
  communicationPreferencesSelected: string[];
  communicationPreferencesShown: string[];
  communicationPreferencesInteracted: boolean;
}

// The shown list travels with the selection so a refusal cannot be confused with an option added after submit.
export const buildCommunicationPreferenceDefaults = (
  offeredOptions: { contactListId: string }[] | null | undefined,
  country: OrganizationCountry | null | undefined
): CommunicationPreferenceDefaults => {
  const contactListIds = (offeredOptions ?? []).map((option) => option.contactListId);

  return {
    communicationPreferencesSelected: areCommunicationPreferencesPreselected(country) ? contactListIds : [],
    communicationPreferencesShown: contactListIds,
    communicationPreferencesInteracted: false,
  };
};
